// @flow

import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Table } from '@medeo/components'
import { getAllObservationsFromPatientId } from '@medeo/observations'
import { connect } from 'react-redux'
import moment from 'moment'

import type { Observation } from '@medeo/user/types/fhir'

type OwnProps = {
  patientId: string
}

type StateProps = {
  observations: Array<Observation>
}

type Props = OwnProps & StateProps

const convertBloodGlucoseValue = (valueQuantity) => {
  switch(valueQuantity.unit) {
    case 'mg/dL':
    return { ...valueQuantity, value: Math.floor(valueQuantity.value ) / 100, unit: 'g/L' }
    default:
    return { ...valueQuantity}
  }
}

const HistoryTable = ({ observations }: Props) => (
  <Table
    headers={[['mesure', 'valeur', 'date']]}
    rows={observations.map(observation => ({ ...observation, valueQuantity: convertBloodGlucoseValue(observation.valueQuantity)}))}
    renderRow={observation => [
      <FormattedMessage key="measure" id={observation.code.coding[0].code}>
        {label => <td>{label}</td>}
      </FormattedMessage>,
      <td key="value">
        {observation.valueQuantity.value} {observation.valueQuantity.unit}
      </td>,
      <td key="date">
        <span>{moment(observation.effectiveDateTime).calendar()}</span>
      </td>
    ]}
  />
)

const mapStateToProps = (state: *, ownProps: OwnProps): StateProps => {
  const allObservations = getAllObservationsFromPatientId(
    state,
    ownProps.patientId
  )
  const observations = allObservations.sort(
    (a, b) => new Date(b.effectiveDateTime) - new Date(a.effectiveDateTime)
  )
  return {
    observations,
    patient: ownProps.patient
  }
}

export default connect(mapStateToProps)(HistoryTable)



// WEBPACK FOOTER //
// ./src/Observations/containers/HistoryTable.js